export class MediaFile {
  _id: string;
  userId: string;
  user: any;
  title: string;
  description: string;
  filePath: string;
  defaultImage: string;
  fileImageArray: any;
  fileType: string;
  uploaded: Date;
  author: string;
  categories: any;
  likes: any;
  reviews: any;
  totalRating: number;
  deleted: boolean;
  uploadDateRange; // used for searching
  uploadStartDate: Date; // used for searching
  uploadEndDate: Date; // used for searching
  materialIds; // used for searching
  subCategories; // for use with subs searching
  resourceCategories: any;
  resourceSubCategories: any;
  likedBy;
  createdAt: Date;
  updatedAt: Date;  
  hasSearchTerms;
  searchText: string;
  name;

  dateCreatedRange; // For filters
  dateCreated; // For filters
  dateCreatedEnd; // For filters
}
